import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteCategory, getCategory } from '../Store/ActionCreators/CategoryActionCreator'
import Sidebar from './Sidebar'
import { Box, Button} from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function AdminCategory() {
  const navigate = useNavigate()
  const [page, setPage] = useState(0);
const [pageSize, setPageSize] = useState(10);

  const columns = [
  // { field: '_id', headerName: 'ID', width: 200 },
      {
    field: "sn",
    headerName: "S.No",
    width: 80,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return page * pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id) + 1;
    }
  },
  {
    field: 'name',
    headerName: 'Category Name',
    width: 200,
  },

  {
  field: 'createdAt',
  headerName: 'Create Date',
  width: 150,
  valueFormatter: (value) => {
    if (!value) return '';
    return new Date(value).toLocaleDateString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  },
},
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
  },
  {
        field: 'edit',
        headerName: 'Edit',
        sortable: false,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            navigate("/updatecategory/" + row._id)
          }}>
           <EditIcon style={{color:"grayblue"}}/>
          </Button>,
      },
      {
        field: 'delete',
        headerName: 'Delete',
        width: 120,
        editable: true,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            dispatch(deleteCategory({ _id: row._id }))
          }
          }>
            <DeleteIcon style={{color:"red"}}/>
          </Button>
      },
];
    const dispatch = useDispatch()
    const categoryList = useSelector((state)=>state.CategoryStateData)

    const rows = categoryList || [];

    useEffect(()=>{
        dispatch(getCategory())
    },[dispatch])

  return (
    <>
        <Box sx={{display:"flex"}}> 
      <Sidebar />
      <Box  className="boxStyle">
            <h4 className='bg-dark text-light p-1 text-center rounded mt-2 mb-3'>Category Details <span style={{ float: 'right', fontWeight: "bold", marginRight: "10px" }}><Link to="/addcategory" style={{ textDecoration: "none", color: "#fff" }}>+</Link></span></h4>
            <h5 className='text-right'style={{textAlign: "right"}}>Total Category : {categoryList.length}</h5>
        <Box sx={{ height: 620, width: '100%' }}>
          <DataGrid
          sx={{
    border: "1px solid #636363ff",
    "& .MuiDataGrid-cell": {
      border: "1px solid #dad8d8ff",
    },
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: "1px solid #636363ff",
    },
  }}

  rows={categoryList}
  columns={columns}
  getRowId={(row) => row._id}
  pageSizeOptions={[5, 10, 20]}
  pagination
  paginationModel={{ page, pageSize }}
  onPaginationModelChange={(model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  }}
/>

        </Box>
      </Box>
      </Box>
    </>
  )
}
